
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/contact",
      function () {
        return require("private-next-pages/india/contact.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/contact"])
      });
    }
  